angular.module('bmsApp.trugreen.job').controller('TGChemicalRecordModalCtrl', function ($scope,
																						$modalInstance,
																						$q,
																						$ngBootbox,
																						TGProductSvc,
																						$filter,
																						$timeout,
																						ConfigService,
																						TaxHelperSvc,
																						TGTreatmentSvc,
																						tgTreatment,
																						tgProduct) {


	function init() {
		self.product = tgProduct;
		self.treatment = tgTreatment;
		if (!angular.isObject(self.product.chemical_record)) {
			angular.extend(self.product, {
				chemical_record: {}
			});
		}
		self.record = self.product.chemical_record;
		self.config = angular.copy(ConfigService.config);
		self.config.uiTimepickerOptions.appendTo = '.modal-body';

		if (self.record.start_time) {
			self.record.start_time = moment(self.record.start_time, "HH:mm:ss");
		}
		if (self.record.finish_time) {
			self.record.finish_time = moment(self.record.finish_time, "HH:mm:ss");
		}

		if (!self.record.rate_of_application) {
			self.record.rate_of_application = self.product.product_attr.application;
		}

		self.loading = false;
	}


	function cancel() {
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				$modalInstance.dismiss('cancel');
			});
	}

	function submit() {

		if (self.formValidator.valid()) {
			var modalResult = {
				product: self.product
			};
			$modalInstance.close(modalResult);
		}
	}

	var self = $scope.TGChemicalRecordModalCtrl = {
		formvalidatorconfig: {},
		formValidator: {},
		loading: true,
		processing: false,
		product: null,
		options: {},
		methods: {
			init: init,
			cancel: cancel,
			submit: submit
		}
	};


});
